import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export interface SignupRequest {
  username: string;
  password: string;
  name: string;
  acceptedTermsOfUse?: boolean;
  acceptedPrivacyPolicy?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  signup(request: SignupRequest, recaptchaToken = ''): Observable<any> {
    // Body mapeado conforme o schema CreateUser do swagger.json
    const body = {
      username: request.username,
      password: request.password,
      name: request.name,
      acceptedTermsOfUse: request.acceptedTermsOfUse ?? false,
      acceptedPrivacyPolicy: request.acceptedPrivacyPolicy ?? false
    };
    return this.authService.getClientCredentialsToken('create-users').pipe(
      switchMap(response => 
        this.http.post(`${environment.authServer}/users`, body, {
          headers: {
            'Authorization': `Bearer ${response.access_token}`,
            'recaptcha-token': recaptchaToken
          }
        })
      )
    );
  }
} 